import React from "react";
import { Slider } from "../../../components/slider/slider";
import { SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../AppContext";
import Counter from "../../../components/increaser-decreaser/counter";
import { epos, Device } from "../../../file.interface";
import { formatAsEuro } from "../../../helpers/helpers";
import DevicesDynamicTable from "../../../components/dynamic-table/devices-dynamic-table";

export interface SelectedDevice extends Device {
  counter: number;
}

const DevicesScreen1: React.FC = () => {
  //
  const navigate = useNavigate();
  const { selectedContractDuration, flowDevices, selectedSiteFlow } =
    useAppContext();

  const devicesNotCompleted =
    flowDevices.length > 0
      ? flowDevices.some((device) => device.cardMachine === null)
      : true;

  const handleNextStep = () => {
    navigate("/terminals-screen-2");
  };

  return (
    <div className="screen-container">
      <h3 className="title-screen">SITE #{selectedSiteFlow + 1}</h3>

      <h4 className="subtitle-screen">Choose your devices</h4>
      <Slider>
        {epos?.map((product, index) => (
          <SwiperSlide key={`${product.id}-${index}`}>
            <div className="product-card">
              <div className="image-container">
                <img
                  src={product.imageUrl}
                  alt={product.name}
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ padding: 20 }}>
                <h3 className="card-title">{product.name}</h3>
                <Counter product={product} flow={flowDevices} />
                <p className="price-by-unit">
                  Price by unit:{" "}
                  {formatAsEuro(product.prices[selectedContractDuration])}{" "}
                  monthly
                </p>
                <p>{product.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Slider>

      {flowDevices.length > 0 && (
        <>
          <h3 className="title-screen">
            Select a card machine for each device
          </h3>
          <h4 className="subtitle-screen">
            Each EPOS device needs to be connected to a card terminal to take
            card payments.
          </h4>
          <DevicesDynamicTable flowDevices={flowDevices} />
        </>
      )}
      <div className="buttons-container">
        {/*         <button
          className="app-button previous-button"
          onClick={() => navigate("/screen-3")}
        >
          Previous
        </button> */}
        {flowDevices.length > 0 ? (
          <button
            className={`app-button next-button ${
              devicesNotCompleted ? "app-button-disabled" : ""
            }`}
            onClick={() => handleNextStep()}
            disabled={devicesNotCompleted}
          >
            Next
          </button>
        ) : (
          <button
            className={`app-button next-button`}
            onClick={() => handleNextStep()}
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
};

export default DevicesScreen1;
